import { useEffect } from "react"

import { emitAppEvent } from "shared/lib/appEventEmitter"
import { useEvent } from "shared/lib/useEvent"
import { AccessibilityMessage } from "shared/ui/accessibility-info/AccessibilityInfo"

import { SHOW_ACCESSIBILITY_MESSAGE } from "./AppEvent"

export function useAccessibilityMessage(
  messages?: AccessibilityMessage | AccessibilityMessage[] | null,
  show = true
) {
  const showAccessibilityMessage = useEvent(
    (nextMessages?: AccessibilityMessage | AccessibilityMessage[] | null) => {
      emitAppEvent(SHOW_ACCESSIBILITY_MESSAGE, { messages: nextMessages })
    }
  )

  useEffect(() => {
    if (messages !== undefined && show) {
      showAccessibilityMessage(messages)
    }
  }, [messages, show])

  return { showAccessibilityMessage }
}
